import React from 'react';

const LABEL = 'Powered by';

export default function AcesCredit({
  variant = 'dark',
  className = '',
  href = 'https://aces-co.com/',
}) {
  const onDark = variant === 'dark' || variant === 'onDark';
  const labelClass = onDark ? 'text-white/60' : 'text-gray-500';
  const hoverClass = onDark ? 'hover:bg-white/10' : 'hover:bg-gray-50';
  const ringClass = onDark ? 'focus-visible:ring-white/40' : 'focus-visible:ring-teal-500/40';
  const logoSrc = onDark ? '/aces-logo-on-dark.svg' : '/aces-logo-on-light.svg';

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${LABEL} ACES — Advanced Communications and Electronics Systems`}
      title="Advanced Communications and Electronics Systems (ACES)"
      className={`group inline-flex items-center gap-2.5 rounded-xl px-2 py-1.5 transition-colors outline-none focus-visible:ring-2 ${hoverClass} ${ringClass} ${className}`.trim()}
    >
      <span className={`text-[10px] font-semibold uppercase tracking-[0.16em] ${labelClass}`}>
        {LABEL}
      </span>
      <img
        src={logoSrc}
        alt="ACES"
        className="h-4 w-auto sm:h-[1.125rem]"
        width={116}
        height={29}
        loading="lazy"
        decoding="async"
      />
    </a>
  );
}
